module.exports = "/_next/static/pages/profile05/ba5ba4bda42f44497b092bdb5867711d.jpg";